import {
  MAP_SELECT_DEVICE,
  MAP_UNSELECT_DEVICE,
  MAP_CLEAR_SELECTION,
  MAP_SET_SELECTION_MODE,
  MAP_SELECT_DEVICES,
  MAP_UNSELECT_DEVICES,
  MAP_SET_TILE_MODE,
  PROCESSING_SELECTION,
  MAP_SET_HOVERED_DEVICES
} from '../../actions/map';

import {
  TOGGLE_EVENT_FORM,
  POST_EVENT
} from '../../actions/events';

import {
  PUT_DEVICE,
} from '../../actions/devices';

const initialState = {
  selected_device_ids: [],
  selection_mode: 'single',
  tile_mode: 'canvas',
  eventModalOpen: false,
  processingSelection: false,
  hoveredDeviceIds: [],
};

const map = (state = initialState, action) => {
  switch(action.type) {
    case `${PROCESSING_SELECTION}_PENDING`:
      return { ...state, processingSelection: true }
    case `${PROCESSING_SELECTION}_REJECTED`:
    case `${PROCESSING_SELECTION}_FULFILLED`:
      return { ...state, processingSelection: false }
    case MAP_SET_TILE_MODE:
      return { ...state, tile_mode: action.tile_mode };
    case MAP_SET_SELECTION_MODE:
      return { ...state, selection_mode: action.selection_mode };
    case MAP_CLEAR_SELECTION:
      return { ...state, selected_device_ids: initialState.selected_device_ids };
    case MAP_SELECT_DEVICE: // Although we might still want to use it, it's replace by MAP_SELECT_DEVICES for performance reasons
      return { ...state, selected_device_ids: [ action.device_id, ...state.selected_device_ids ] };
    case MAP_UNSELECT_DEVICE: // Although we might still want to use it, it's replace by MAP_SELECT_DEVICES for performance reasons
      return { ...state, selected_device_ids: state.selected_device_ids.filter(device_id => device_id !== action.device_id) };
    case MAP_SELECT_DEVICES:
      return { ...state, selected_device_ids: [ ...action.device_ids, ...state.selected_device_ids ] };
    case MAP_UNSELECT_DEVICES:
      return { ...state, selected_device_ids: state.selected_device_ids.filter(d_id => action.device_ids.indexOf(d_id) === -1) };
    case MAP_SET_HOVERED_DEVICES:
      return { ...state, hoveredDeviceIds: action.ids}
    // case `${PUT_DEVICE}_FULFILLED`:
    //   return { ...state, selected_device_ids: state.selected_device_ids.filter(device_id => device_id !== action.payload.id) };
    // // those two should not belong here :s
    case TOGGLE_EVENT_FORM:
      return { ...state, eventModalOpen: !state.eventModalOpen };
    case `${POST_EVENT}_FULFILLED`:
      return { ...state, eventModalOpen: false }

    default:
      return state;
  }
}

export default map;



// WEBPACK FOOTER //
// ./src/reducers/ui/map.js